import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateWords } from '../state_words';

export const local_word_with_related_words_create_in_progress_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.WORDS_WITH_RELATED_WORDS_CREATE_IN_PROGRESS_DELETE,
  payload,
});

export const init_local_word_with_related_words_create_in_progress_delete = (state: StateWords, action: PayloadAction<string[]>) => {
  if (action.payload.is_empty()) return;

  for (let word_english of action.payload) {
    state.words_with_related_words_create_in_progress.delete(word_english);
  }

  //need to trigger re-render
  state.words_with_related_words_create_in_progress = new Set(state.words_with_related_words_create_in_progress);
};
